import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import NavBar from "../navbar/NavBar"
import Footer from "../footer/Footer"

import banner1 from '../../assets/Image/InfoSession_Banner.jpg';
import banner2 from '../../assets/Image/InfoSession2_Banner.jpg';
import ImageMarquee from './ImageMarquee';

const allRoutes = ['/about', '/programs', '/events', '/news', '/donate', '/outreach', '/networking'];
class Home extends Component {

    constructor(props) {
        super(props)
        this.state = {
            doRedirect: false,
            redirect: {
                pathname: '',
                redirectProps: {}
            }
        }
    }

    handleRedirect = (e, path, param) => {
        e.preventDefault()
        if (!allRoutes.includes(path)) {
            console.log('Invalid route');
            return;
        }
        if (path == this.path) {
            this.props.handler(param);
            return;
        }
        this.setState({
            doRedirect: true,
            redirect: {
                pathname: path,
                redirectProps: { title: param }
            }
        })
    }

    registerClicker() {

    }

    render() {
        if (this.state.doRedirect) {
            return (
                <Redirect to={
                    {
                        pathname: this.state.redirect.pathname,
                        state: this.state.redirect.redirectProps
                    }
                } />
            )
        }
        return (
            <div id="home-wrapper">
                <NavBar path='/' />
                <div className="bg">
                    <div style={{"height": "420px"}}><ImageMarquee /></div>
                    <div className="container bg-content">
                            <div style={{ "text-shadow": "2px 2px 4px #000000", "background": "linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.1))" }}>
                                <br />
                                <h1 style={{ color: "white" }}><b>Welcome to the Education Arm of the </b></h1>
                                <h1 style={{ color: "white" }}><b>San Diego Nanotechnology Infrastructure</b></h1>
                                <h3 className="homepage-intro" style={{ color: "#DCF5DC" }}>A <b className={"boldlettershome"}>C</b>enter of <b className={"boldlettershome"}>E</b>xcellence
                                    in <b className={"boldlettershome"}>N</b>ano<b className={"boldlettershome"}>T</b>echnology <b className={"boldlettershome"}>E</b>ducational <b className={"boldlettershome"}>R</b>esources</h3>
                                <h3 className={"boldlettershome"}><b>C.E.N.T.E.R.</b></h3>
                            </div>
                    </div>
                </div>

                <Footer />
            </div>

        );
    }
}

export default Home;
